require('sass/brands/locations.jcpenney.com/location/default.scss');
require('js/location-script.js');
